<template>
  <div>
    <div
      v-if="step.construction_step.is_valid"
      class=" is-margin-top-xsmall">
      <div class="columns is-gapless has-background-white-bis is-marginless-bottom is-minH64p">
        <div
          class="column is-narrow is-flex is-padding-small"
          :class="step.construction_step.is_valid ? 'has-background-success' : 'has-background-danger'">
          <span class="icon has-text-white is-self-centered"><i
            :class="step.construction_step.is_valid ? 'fa-check-circle' : 'fa-exclamation-circle'"
            class="fas fa-check-circle"></i></span>
        </div>
        <div class="column is-padding-top">
          <div class="is-padding-left is-padding-bottom-small">
            <span class="title is-4">{{ step.construction_step.name }}
              ({{ step.construction_step.progress }}%)</span>
          </div>
          <div class="columns is-gapless is-padding-left is-marginless-bottom">
            <div class="column is-3 is-padding-right">
              <r-label
                :is-required="false"
                :label="'Montant attendu'"
                :for-id="''"></r-label>
            </div>
            <div class="column is-3 is-padding-right">
              <r-label
                :is-required="false"
                :label="'Montant perçu'"
                :for-id="''"></r-label>
            </div>
            <div class="column">
              <r-label
                :is-required="false"
                :label="'Reception paiement'"
                :for-id="''"></r-label>
            </div>
          </div>
          <div class="columns is-gapless is-margin-top-xxsmall is-padding-left has-background-white-ter is-vcentered is-minH50p is-border-top">
            <div class="column is-3 is-padding-right">
              <b class="is-uppercase">{{ amountExpected }} € TTC</b>
            </div>
            <div class="column is-3 is-padding-right">
              <div class="field has-addons">
                <p
                  class="control is-expanded"
                  :class="{'is-border': !isPromoteur}">
                  <v-input
                    :id="idx + '-amount_received'"
                    :name="idx + '-amount_received'"
                    :model="step.amount_received"
                    :number="true"
                    :disabled="!isPromoteur"
                    input-type="number"
                    @input="$store.commit('modifyCurrentAdv', { key: `construction_steps[${idx}].amount_received`, value: $event }); step.amount_received = $event"
                    v-validate="'decimal:2'"
                    :errors-bag="errors"
                    data-vv-value-path="val"
                    data-vv-as="Fonds recus">
                  </v-input>
                </p>
                <p class="control is-nowrap">
                  <a class="button is-static is-border is-padding-left-xsmall is-padding-right-xsmall has-text-dark"><span class="has-text-weight-bold">€ TTC</span></a>
                </p>
              </div>
            </div>
            <div class="column is-3">
              <date-picker
                :model="step.amount_received_date"
                @input="$store.commit('modifyCurrentAdv', { key: `construction_steps[${idx}].amount_received_date`, value: $event }); step.amount_received_date = $event"
                class="is-self-centered"
                :field-class="'is-margin-left-xxsmall is-margin-right-xsmall is-self-centered'"
                :input-class="'is-fullwidth'"
                :style-version="2"
                :is-required="false"
                :disabled="!isPromoteur"></date-picker>
            </div>
            <div class="column">
              <!-- <div
                v-for="letter in letters"
                :key="letter.value"
                :value="letter.value"
                class="has-text-right is-self-stretched">
                <button
                  v-if="step.construction_step.is_valid && isAdmin && letter.sending_date && sageConnector"
                  :disabled="!isAdmin || !validBuyers"
                  @click="sendAdfToSage"
                  data-tooltip="Contact(s) non valide"
                  :class="{'tooltip is-tooltip-left' : !validBuyers}"
                  class="button is-minH100 is-dark is-small is-radiusless is-minW154p custom-top ">
                  <span v-if="!loadingDoc"><span><i class="fas fa-cogs is-margin-xsmall"></i></span> <span class="is-size-7">ENVOYER ADF SAGE</span></span>
                  <span v-else><i class="fas fa-spinner fa-spin"></i></span>
                </button>
              </div> -->
              <div class="has-text-right is-self-stretched">
                <button
                  v-if="step.construction_step.is_valid && isAdmin && letters.length <= 1"
                  :disabled="!isAdmin || !validBuyers"
                  @click="openPreview"
                  data-tooltip="Contact(s) non valide"
                  :class="{'tooltip is-tooltip-left' : !validBuyers}"
                  class="button is-minH100 is-dark is-small is-radiusless is-minW180p custom-top">
                  <span v-if="!loadingDoc"><span><i class="fas fa-cogs is-margin-xsmall"></i></span> <span class="is-size-7">GÉNÉRER COURRIER ADF</span></span>
                  <span v-else><i class="fas fa-spinner fa-spin"></i></span>
                </button>
              </div>
              <div
                v-for="letter in letters"
                :key="letter.value"
                :value="letter.value"
                class="has-text-right is-self-stretched">
                <button
                  v-if="step.construction_step.is_valid && isAdmin && letter.sending_date && sageConnector"
                  :disabled="!isAdmin && !validBuyers"
                  @click="sendAdfToSage"
                  data-tooltip="Contact(s) non valide"
                  :class="{'tooltip is-tooltip-left' : !validBuyers}"
                  class="button is-minH100 is-success is-small is-radiusless is-minW154p">
                  <span v-if="!loadingDoc"><span><i class="fas fa-cogs is-margin-xsmall"></i></span> <span class="is-size-7">ENVOYER ADF VERS SAGE</span></span>
                  <span v-else><i class="fas fa-spinner fa-spin"></i></span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <sru-item
        v-for="(letter, index) of letters"
        @getAppelDeFondLre="$emit('getAppelDeFondLre')"
        :source="letter"
        :buyers="buyers"
        :step-lre="stepLre"
        :key="index"
        :letters="letters"
        :index="index"
        :appel-de-fond-index="idx"
        :sru-index="index"
        :request-elem="requestElem">
      </sru-item>
      <div
        v-if="buyers.length > 1 && letters.length < buyers.length"
        @click="addCoReco()">
        <button class="button is-dark is-fullwidth is-radiusless is-min-height-50">
          <span v-if="!loadingCo">AJOUTER UN COURRIER RECOMMANDÉ CO-ACQUÉREUR</span>
          <span v-else><i class="fas fa-spinner fa-spin"></i></span>
        </button>
      </div>
    </div>
    <div
      v-else
      class="has-background-white-bis">
      <div
        style="opacity: 0.6"
        class="columns is-gapless has-background-lighter is-minH50p is-margin-top-xsmall is-border">
        <div class="column is-narrow is-w50p has-background-white-ter is-border-right"></div>
        <div class="column is-padding-left is-padding-top-small is-padding-bottom-small">
          <span class="is-uppercase has-text-weight-medium">{{ step.construction_step.name }}
            ({{ step.construction_step.progress }}%) : <b>{{ amountExpected }} € TTC</b></span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Adv } from '@/mixins'
import { mapGetters, mapState } from 'vuex'
import SruItem from './SruItem'

export default {
  name: 'AppelDeFondsItem',
  components: { SruItem },
  mixins: [Adv],
  props: {
    toOpen: String,
    step: {
      type: Object,
      required: true
    },
    lreList: {
      type: Array
    },
    idx: Number,
    furniturePrice: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      loadingDoc: false,
      loadingCo: false,
      edit: false,
      open: false,
      letterDate: true
    }
  },
  computed: {
    ...mapGetters(['isPromoteur', 'constructionSteps']),
    ...mapState({
      currentAccount: 'currentAccount'
    }),
    /**
      * amount Expected
      * @returns {number}
      */
    amountExpected () {
      if (this.adv && this.adv.sale_price_ttc && this.step && this.step.construction_step) {
        return this.adv.is_furniture_adf ? Math.round(Number(this.adv.sale_price_ttc) * Number(this.step.construction_step.progress)) / 100 : Math.round(Number(this.adv.sale_price_ttc - this.furniturePrice) * Number(this.step.construction_step.progress)) / 100
      } else {
        return null
      }
    },
    /**
      * letters of this construction step
      * @returns {object}
      */
    letters () {
      return this.constructionSteps[this.idx].letters
    },
    /**
      * request elem
      * @returns {object}
      */
    requestElem () {
      let elem = {
        step_uuid: this.step.construction_step.step_uuid,
        adv_pk: this.adv.pk
      }
      return elem
    },
    /**
      * get buyers without recommanded letter
      * @returns {array}
      */
    missingBuyer () {
      let buyersArray = this.buyers.map(x => x.pk)
      for (let letter of this.letters) {
        if (buyersArray.includes(letter.buyer_pk)) {
          const index = buyersArray.findIndex(x => x === letter.buyer_pk)
          if (index >= 0) {
            buyersArray.splice(index, 1)
          }
        }
      }
      return buyersArray
    },
    /**
      * return current lre
      * @returns {object}
      */
    stepLre () {
      return this.lreList.filter(x => {
        return x.details.construction_step_uuid === this.requestElem.step_uuid
      })
    },
    sageConnector () {
      return this.currentAccount.sage_connector
    }
  },
  methods: {
    /**
      * add recommended courrier
      */
    async addCoReco () {
      this.loadingCo = true
      try {
        let { data } = await this.$api.axios.put(`reservations/${this.requestElem.adv_pk}/adf/${this.requestElem.step_uuid}/${this.missingBuyer[0]}`)
        let payload = {
          construstion_steps: data
        }
        await this.$store.dispatch('patchAdvConstructionStep', payload)
        this.$toasted.global.success('Courrier Recommandé co-acquéreur créé')
      } catch (err) {
        this.handleError(err)
      } finally {
        this.loadingCo = false
      }
    },
    /**
      * open document preview
      */
    async openPreview (buyerPk) {
      this.loadingDoc = true
      try {
        const request = await this.getCustomPdf()
        let params = {
          hasButton: this.adv.buyer_space_id,
          link: request.data,
          adf: this.step.construction_step
        }
        this.$store.commit('setModal', { mode: 'DOCUMENT_PREVIEW_ADF', params })
      } catch (err) {
        console.log(err)
      } finally {
        this.loadingDoc = false
      }
    },
    /**
      * get pdf
      * @returns {string} url
      */
    getPdf () {
      let url = `pdf/adf/${this.$route.params.id}/${this.buyers[0].pk}/${this.step.construction_step.step_uuid}`
      if (this.buyers.length > 1) {
        url = `${url}?co_buyer=${this.buyers[1].pk}`
      }
      return this.$api.axios.get(url)
    },
    /**
      * get custom pdf
      * @returns {string} url
      */
    getCustomPdf () {
      const payload = {
        'reservation': this.adv.pk,
        'buyer': this.adv.buyers[0],
        'construction_step_uuid': this.step.construction_step.step_uuid
      }
      if (this.buyers.length > 1) {
        payload.co_buyer = this.buyers[1]
      }
      let url = this.$api.axios.post(`/preview-adf`, payload)
      return url
    },
    async sendAdfToSage () {
      const payload = {
        reservation_pk: this.adv.pk,
        user_pk: this.currentUser.pk,
        construction_step: this.step
      }
      const { data } = await this.$api.post(this.$resources.TRANSFER_SAGE_ADF, this.$cleanPayload(payload))
      if (data) {
        this.$toasted.global.success('L\'appel de fond à été envoyé.')
      }
    }
  }
}
</script>
<style scoped>
.custom-top {
  margin-bottom: 5px;
}
</style>
